module.exports = __webpack_public_path__ + "img/login12.d5190216.png";